import { Component, ViewEncapsulation, OnInit, OnDestroy, ViewChildren, AfterViewInit, QueryList, ElementRef, HostListener, inject } from "@angular/core";
import { Router, NavigationStart, RouterOutlet, RouterModule, RouterLink } from '@angular/router';
import {ToastrModule, ToastrService} from 'ngx-toastr';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { AlertService, AlertDialog, DialogType, AlertMessage, MessageSeverity } from '../services/alert.service';
import { NotificationService } from "../services/notification.service";
import { AppTranslationService } from '../services/app-translation.service';
import { AccountService } from '../services/account.service';
import { LocalStoreManager } from '../services/local-store-manager.service';
import { AppTitleService } from '../services/app-title.service';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';
import { Permission } from '../models/permission.model';
import { LoginComponent } from "../components/login/login.component";
import { OrderService } from "../services/orders.service";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { AccountRemovecomponent } from "./controls/account-remove.component";
import { DialogData } from "./controls/information-dialog.component";
import { GoogleAnalyticsService, NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { CookieBanner } from "../cookie-banner/cookie-banner";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TutorialDialogComponent } from "./main/tutorial.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "./main/shared.module";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { AnalyticsService } from "../services/analytics.service";

var alertify: any = require('../assets/scripts/alertify.js');


@Component({
    selector: "app-root",
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [OrderService],
    imports:[CookieBanner,
      RouterOutlet,
      MatProgressSpinner,
      TutorialDialogComponent,
        RouterLink, RouterModule,
        NgbModule,
        NgxGoogleAnalyticsRouterModule,
        FormsModule,
        ReactiveFormsModule,
        //ImageUploadModule.forRoot(),
        MatCheckboxModule,
        MatDialogModule,
        //VideoModule,
        //NgxDatatableModule
        CookieBanner,
        RouterLink, RouterModule
    ],
    standalone: true
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy{
    @HostListener('window:beforeunload', ['$event'])
    @HostListener('window:pagehide', ['$event'])
    doSomething($event) {
        if (!this.authService.isLoggedIn && this.orderService.changedAfterOrder)
            $event.returnValue = 'Your data will be lost!';
    }
  isAppLoaded: boolean;
  isUserLoggedIn: boolean;
  shouldShowLoginModal: boolean;
  removePrebootScreen: boolean = true;
  isMenuExpanded: boolean = false;
  newNotificationCount = 0;
    appTitle = "Dobierz gniazdka i łączniki elektryczne do swojego domu!";

  stickyToasties: number[] = [];

  dataLoadingConsecutiveFailurs = 0;
  notificationsLoadingSubscription: any;

    @ViewChildren('loginModal,loginControl')
  modalLoginControls: QueryList<any>;

  loginModal: ModalDirective;
  loginControl: LoginComponent;


  get notificationsTitle() {

    let gT = (key: string) => this.translationService.getTranslation(key);

    if (this.newNotificationCount)
      return `${gT("app.Notifications")} (${this.newNotificationCount} ${gT("app.New")})`;
    else
      return gT("app.Notifications");
  }

  toastr = inject(ToastrService);
  constructor(storageManager: LocalStoreManager,
    private accountService: AccountService, private alertService: AlertService, private notificationService: NotificationService, private appTitleService: AppTitleService,
      private authService: AuthService, private translationService: AppTranslationService, public configurations: ConfigurationService, public router: Router,
      public dialog: MatDialog,
      public gaService: GoogleAnalyticsService,
      private orderService: OrderService,
      private analytics: AnalyticsService) {
      analytics.setGaService(gaService);

    storageManager.initialiseStorageSyncListener();

    translationService.addLanguages(["en"]);
    translationService.setDefaultLanguage('en');


    //toastrService.toastrConfig. = 'bootstrap';
    //this.toastr.positionClass = 'top-right';
    //this.toastrConfig.limit = 1;
    //this.toastrConfig.showClose = true;

    this.appTitleService.appName = this.appTitle;
  }


  ngAfterViewInit() {

    this.modalLoginControls.changes.subscribe((controls: QueryList<any>) => {
      controls.forEach(control => {
        if (control) {
          if (control instanceof LoginComponent) {
            this.loginControl = control;
            this.loginControl.modalClosedCallback = () => this.loginModal.hide();
          }
          else {
            this.loginModal = control;
            this.loginModal.show();
          }
        }
      });
    });
  }


  onLoginModalShown() {
    this.alertService.showStickyMessage("Session Expired", "Your Session has expired. Please log in again", MessageSeverity.info);
  }


  onLoginModalHidden() {
    this.alertService.resetStickyMessage();
    this.loginControl.reset();
    this.shouldShowLoginModal = false;

    if (this.authService.isSessionExpired)
      this.alertService.showStickyMessage("Session Expired", "Your Session has expired. Please log in again to renew your session", MessageSeverity.warn);
  }


  onLoginModalHide() {
    this.alertService.resetStickyMessage();
    }
    

  ngOnInit() {
      this.isUserLoggedIn = this.authService.isLoggedIn;
      /*
      if (!this.isUserLoggedIn) {
          window.onbeforeunload = 
          function () {
              return "You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.  Are you sure you want to exit this page?";
          }
      }
      */

    // 1 sec to ensure all the effort to get the css animation working is appreciated :|, Preboot screen is removed .5 sec later
    setTimeout(() => this.isAppLoaded = true, 50);
    setTimeout(() => this.removePrebootScreen = true, 1000);

    setTimeout(() => {
      if (this.isUserLoggedIn) {
        this.alertService.resetStickyMessage();

        //if (!this.authService.isSessionExpired)
        this.alertService.showMessage("Login", `Welcome back ${this.userName}!`, MessageSeverity.default);
        //else
        //    this.alertService.showStickyMessage("Session Expired", "Your Session has expired. Please log in again", MessageSeverity.warn);
      }
    }, 200);

      console.log("subscribe to alerts");
    //this.alertService.getDialogEvent().subscribe(alert => this.showDialog(alert));
    this.alertService.getMessageEvent().subscribe(message => this.showToast(message, false));
    this.alertService.getStickyMessageEvent().subscribe(message => this.showToast(message, true));

    this.authService.reLoginDelegate = () => this.shouldShowLoginModal = true;

    this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
      this.isUserLoggedIn = isLoggedIn;


      if (this.isUserLoggedIn) {
        //this.initNotificationsLoading();
      }
      else {
        this.unsubscribeNotifications();
      }

      setTimeout(() => {
        if (!this.isUserLoggedIn) {
          this.alertService.showMessage("Session Ended!", "", MessageSeverity.default);
        }
      }, 500);
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        let url = (<NavigationStart>event).url;

        if (url !== url.toLowerCase()) {
          this.router.navigateByUrl((<NavigationStart>event).url.toLowerCase());
        }
      }
    });
  }


  ngOnDestroy() {
    this.unsubscribeNotifications();
  }


  private unsubscribeNotifications() {
    if (this.notificationsLoadingSubscription)
      this.notificationsLoadingSubscription.unsubscribe();
  }



  initNotificationsLoading() {
      
    this.notificationsLoadingSubscription = this.notificationService.getNewNotificationsPeriodically()
      .subscribe(notifications => {
        this.dataLoadingConsecutiveFailurs = 0;
        this.newNotificationCount = notifications.filter(n => !n.isRead).length;
      },
      error => {
        this.alertService.logError(error);

        if (this.dataLoadingConsecutiveFailurs++ < 20)
          setTimeout(() => this.initNotificationsLoading(), 5000);
        else
          this.alertService.showStickyMessage("Load Error", "Loading new notifications from the server failed!", MessageSeverity.error);
      });
      
  }


  markNotificationsAsRead() {

    let recentNotifications = this.notificationService.recentNotifications;

    if (recentNotifications.length) {
      this.notificationService.readUnreadNotification(recentNotifications.map(n => n.id), true)
        .subscribe(response => {
          for (let n of recentNotifications) {
            n.isRead = true;
          }

          this.newNotificationCount = recentNotifications.filter(n => !n.isRead).length;
        },
        error => {
          this.alertService.logError(error);
          this.alertService.showMessage("Notification Error", "Marking read notifications failed", MessageSeverity.error);

        });
    }
  }

  showToast(message: AlertMessage, isSticky: boolean) {

    if (message == null) {
      for (let id of this.stickyToasties.slice(0)) {
        this.toastr.clear(id);
      }

      return;
    }
  


    switch (message.severity) {
      case MessageSeverity.info: this.toastr.info(message.summary); break;
      case MessageSeverity.success: this.toastr.success(message.summary); break;
      case MessageSeverity.error: this.toastr.error(message.summary); break
      case MessageSeverity.warn: this.toastr.warning(message.summary); break;
    }
  }





  logout() {
      this.authService.logout();
      this.orderService.clearContext();
        this.authService.redirectLogoutUser();
    }


  getYear() {
    return new Date().getUTCFullYear();
  }


  openMenu(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.isMenuExpanded = true;
  }


  collapseMenu() {
    this.isMenuExpanded = false;
  }


  get userName(): string {
    return this.authService.currentUser ? this.authService.currentUser.userName : "";
  }


  get fullName(): string {
    return this.authService.currentUser ? this.authService.currentUser.fullName : "";
  }



  get canViewCustomers() {
    return this.accountService.userHasPermission(Permission.viewUsersPermission); //eg. viewCustomersPermission
  }

  get canViewProducts() {
    return this.accountService.userHasPermission(Permission.viewUsersPermission); //eg. viewProductsPermission
  }

  get canViewOrders() {
    return true; //eg. viewOrdersPermission
    }

    
    
    getBackground() {
        if (window.location.pathname == '/')
            return 'backed_main_page';
        else
            return 'backed_main_container';
    }
    get isMainPage(): boolean {
        return window.location.pathname == '/';
    }

    get isSePage(): boolean {
        return window.location.pathname == '/se';
    }

    get isRegisterPage(): boolean {
        return window.location.pathname == '/rejestracja';
    }


    removeAccountDialog() {
        let newDialog: DialogData = {
            messageTitle: "Ostrzeżenie",
            messageBody: "Czy na pewno chcesz usunąć swoje konto z systemu?",
            url: null,
            confirmCallback: null
        };
        setTimeout(() => {
            const dialogRef = this.dialog.open(AccountRemovecomponent, {
                width: '350px'
            });
        }, 1);

    }
}
